// extracted by mini-css-extract-plugin
export var active = "_tl-1";
export var circle = "_tl-0";
export var completed = "_tl-2";
export var connector = "_tl-4";
export var connectorCompleted = "_tl-7";
export var connectorSpacer = "_tl-5";
export var iconStrokeOverride = "_tl-8";
export var labelContainer = "_tl-6";
export var pending = "_tl-3";